const chunkArray = <T>(data: T[], chunkSize: number): T[][] => {
  if (!chunkSize) throw new Error("Chunk size must be at least 1");
  let chunks = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunks.push(data.slice(i, i + chunkSize));
  }
  return chunks;
};
export default chunkArray;
